module.exports = __webpack_public_path__ + "img/mis-listas.86adb2fa.svg";